import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './MapToolButton.scss';

export class MapToolButton extends Component {
  static propTypes = {
    label: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    className: PropTypes.string
  };

  render () {
    const { onClick, label, className } = this.props;
    return (
      <button type='button' className={['map-tool-button', className].join(' ')} onClick={onClick}>
        {label}
      </button>
    );
  }
}
